import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Content = styled('div')(() => ({
  height: '2.75rem',
  borderRadius: '0.5rem',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '16rem',
  },
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  gap: '1rem',
  padding: '0.25rem',
}));

export const ToggleContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  height: '100%',
  width: '100%',
  borderRadius: '0.5rem',
  backgroundColor: theme.palette.primary.light,
}));

export const ToggleButton = styled('div')<any>(({ selected }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  justifyContent: 'center',
  borderRadius: '0.5rem',
  padding: '0.5rem',
  backgroundColor: selected ? theme.palette.primary.dark : 'transparent',
  color: theme.palette.common.white,
  cursor: 'pointer',
  transition: 'background-color 0.3s ease, color 0.3s ease',
}));
